import * as React from "react";

function PrjUpdateDelIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={22} height={22} rx={3} fill="#D5D5D5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.301 5.52a.565.565 0 00-.264.239c-.05.092-.053.13-.06.666l-.007.569H6.872l-.119.059a.514.514 0 00-.186.156c-.06.088-.067.116-.067.29 0 .177.006.202.07.293a.592.592 0 00.174.155L6.847 8h8.282l.104-.054a.539.539 0 00.181-.17c.075-.11.078-.124.07-.293-.01-.224-.08-.341-.26-.431l-.12-.06h-2.098L13 6.426c-.007-.556-.008-.57-.065-.673a.64.64 0 00-.16-.175l-.102-.072-1.656-.004c-1.057-.003-1.678.004-1.715.018zm2.672 1.227v.247H10.004V6.5H11.973v.246zm-4.7 1.791a.515.515 0 00-.256.265c-.032.078-.037.421-.037 3.016 0 3.171-.003 3.089.128 3.436.186.493.63.94 1.116 1.122.355.134.317.132 2.764.132 2.447 0 2.41.002 2.764-.132.482-.181.93-.63 1.112-1.112.136-.361.132-.25.132-3.448 0-2.808-.003-2.94-.044-3.03a.518.518 0 00-.885-.078L14 8.806l-.012 2.955c-.012 3.214-.002 2.978-.137 3.242-.117.228-.41.428-.697.476-.184.03-4.147.03-4.331 0-.292-.048-.58-.245-.698-.477-.134-.263-.124-.028-.137-3.24l-.011-2.956-.068-.097a.536.536 0 00-.636-.171zm2.485 1.001a.515.515 0 00-.225.225c-.043.083-.045.165-.045 1.983v1.895l.055.104c.03.057.1.135.154.173.092.065.116.07.293.07.175 0 .203-.006.29-.066a.514.514 0 00.157-.187l.06-.119V9.886l-.06-.12a.514.514 0 00-.156-.186c-.083-.057-.123-.068-.275-.073-.13-.005-.197.004-.248.032zm2.015-.005a.512.512 0 00-.246.254c-.044.096-.045.173-.046 1.965v1.864l.059.12c.088.175.207.25.419.26.213.01.341-.051.453-.216l.076-.113v-1.909c0-2.072.006-1.968-.125-2.113-.123-.135-.413-.19-.59-.112z"
        fill="#000"
      />
    </svg>
  );
}

export default PrjUpdateDelIcon;
